import { apiRequestWithChecks } from "./api";


export const alerts = {
    list: function (token, status, search, pageNum, pageSize, filters, sort, skipTotal) {
        return apiRequestWithChecks("POST", "/api/alerts/list", {
            "Authorization": "Bearer " + token
        },
            {
                status: status,
                PageNum: pageNum,
                PageSize: pageSize,
                search: search,
                filters: filters,
                sort: sort,
                skipTotal: skipTotal
            });
    },

    save: function (token, model) {
        return apiRequestWithChecks("POST", "/api/alerts/bulk", {
            "Authorization": "Bearer " + token
        }, model);
    },

    getDetails: function (token, alertId) {
        return apiRequestWithChecks("GET", "/api/alerts?id=" + alertId, {
            "Authorization": "Bearer " + token
        });
    },

    messagePreview: function (token, alertId) {
        return apiRequestWithChecks("GET", "/api/alerts/messagepreview?id=" + alertId, {
            "Authorization": "Bearer " + token
        });
    },

    deleteAlert: function (token, alertId) {
        return apiRequestWithChecks("DELETE", "/api/alerts?id=" + alertId, {
            "Authorization": "Bearer " + token
        });
    },

    templates: function (token, alertType) {
        return apiRequestWithChecks("GET", "/api/alerts/templates?alertType=" + alertType, {
            "Authorization": "Bearer " + token
        });
    },

    templatesList: function (token, search, communicationType, pageNum, pageSize, filters, skipTotal) {
        return apiRequestWithChecks("POST", "/api/templates/list", {
            "Authorization": "Bearer " + token
        }, {
            search: search,
            communicationType: communicationType,
            PageNum: pageNum,
            PageSize: pageSize,
            filters: filters || {},
            skipTotal: skipTotal,
        });
    },

    templateFilterOptions: function (token) {
        return apiRequestWithChecks("GET", "/api/templates/filter-options", {
            "Authorization": "Bearer " + token
        });
    },

    getTemplateById: function (token, id) {
        return apiRequestWithChecks("GET", "/api/templates/" + id, {
            "Authorization": "Bearer " + token
        });
    },

    editTemplate: function (token, model) {
        return apiRequestWithChecks("PUT", "/api/templates/edit", {
            "Authorization": "Bearer " + token
        }, model);
    },

    duplicateTemplate: function (token, id) {
        return apiRequestWithChecks("POST", `/api/templates/${id}/duplicate`, {
            "Authorization": "Bearer " + token
        });
    },

    saveTemplate: function (token, model) {
        return apiRequestWithChecks("POST", "/api/templates/save", {
            "Authorization": "Bearer " + token
        }, model);
    },

    deleteTemplates: function (token, ids) {
        return apiRequestWithChecks("DELETE", "/api/templates/delete", {
            "Authorization": "Bearer " + token
        }, { ids });
    },


    getMessagePreviewEmailRecipientList: function (token, request) {
        return apiRequestWithChecks(
            "POST",
            "/api/messagepreview/GetMessagePreviewEmailRecipientList",
            {
                "Authorization": "Bearer " + token,
            },
            request
        );
    },

    getMessagePreviewSmsRecipientList: function (token, request) {
        return apiRequestWithChecks(
            "POST",
            "/api/messagepreview/GetMessagePreviewTextSMSRecipientList",
            {
                "Authorization": "Bearer " + token,
            },
            request
        );
    },

    getMessagePreviewVoiceRecipientList: function (token, request) {
        return apiRequestWithChecks(
            "POST",
            "/api/messagepreview/GetMessagePreviewVoiceRecipientList",
            {
                "Authorization": "Bearer " + token,
            },
            request
        );
    },
}